/* TODO: t() */
import React, { ComponentProps } from 'react';
import { TouchableOpacity } from 'react-native';

type TouchableProps = ComponentProps<typeof TouchableOpacity>;
type Props = TouchableProps & {
  href: string;
  target?: '_blank' | '_top' | '_self';
  download?: boolean;
  children?: React.ReactNode;
};

/**
 * This is the block-level counterpart of <Link>. It is used for wrapping
 * non-text elements (such as an image). It uses <TouchableOpacity> (which
 * renders a <View>) under the hood.
 */
function TouchableLink(props: Props) {
  let { href, target, download, ...otherProps } = props;
  return (
    <TouchableOpacity
      href={href}
      hrefAttrs={{ target, download }}
      {...otherProps}
    />
  );
}

export default TouchableLink;
